import React, { useEffect, useState } from 'react';
import '../css/BookSlot.css';
import DateAge from '../../_helper/utils.js/DateAge';
import InputField from '../../../common_component/component/InputField';
import CuDropdown from '../../../common_component/component/CuDropdown';
import CustomButton from '../../../common_component/component/CustomButton';
import CuForm from '../../../common_component/component/CuForm';
import { useItemsFilter } from '../../../_helper/actions/app/items';
import { ApiEndPoint } from '../../../_helper/constant/api-types';
import { useAtom } from 'jotai';
import { clinicAtom } from '../../../_helper/constant/constant-atom';
import { useMediaQuery } from 'react-responsive';
// import { capitalizeFirstWord } from "../../_helper/utils.js/utils";
import { permissionAtom } from '../../../_helper/constant/constant-atom';
import { checkPermission } from '../../../roles_and_permissions/_features';
import { toast } from 'react-toastify';

export const gender = [
  { id: 1, label: 'Male' },
  { id: 2, label: 'Female' },
  { id: 3, label: 'Other' },
];

const BookSlot = ({
  value,
  onChange,
  onSubmit,
  existingUserOptions,
  handleAddNewFamilyMember,
  isLoading,
  bookbtnLoading,
  handleSelectInstitution,
  institutionCustmer,
  closeModal,
  manualTime,
  isNotification,
  setIsNotification,
  isEdit,
  setIsEdit,
  customFields,
  resetState,
  clinicOptions,
  setSelectedClinicOption,
  selectedClinicOption,
  // setIsAddNew,
  // isAddNew,
}) => {
  const [isInstitution, setIsInstitution] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [institutionSearchInput, setInstitutionSearchInput] = useState('');
  // const [isAddNew, setIsAddNew] = useState(false);

  const [permission] = useAtom(permissionAtom);

  const sm = !useMediaQuery({ query: '(min-width:1024px)' });

  const [errors, setErrors] = useState({});

  const handleInstitutionToggle = (e) => {
    setIsInstitution((prev) => !prev);
    resetState();
  };

  const { data: institutionData } = useItemsFilter(
    ApiEndPoint.INSTITUTION_CUSTOMERS,
    `?action=getInstitutionCustomers&frontend=True&clinic_id=${clinic?.id}&institution_name__icontains=${institutionSearchInput}`,
    isInstitution && clinic?.id && institutionSearchInput?.length > 0
      ? true
      : false,
  );

  useEffect(() => {
    if (institutionData?.length) {
      const options = institutionData?.map((ins) => ({
        key: ins?.id,
        value: ins?.id,
        text: ins?.institution_name,
      }));
      setInstitutionOptions(options);
    }
  }, [institutionData]);

  const handleInstitutionChange = (val) => {
    const selectedCustomer = institutionData?.find((ins) => ins?.id === val);
    if (selectedCustomer) {
      handleSelectInstitution(selectedCustomer?.id);
    }
  };

  const handleSelectClinicOption = (val) => {
    setSelectedClinicOption(val);
  };

  const checkIsInstitution = (val) => {
    if (!isInstitution) {
      handleAddNewFamilyMember(val);
    } else {
      toast.error('You cannot add family members of an institution patient');
    }
  };

  return (
    <>
      <CuForm onSubmit={onSubmit}>
        {!sm && (
          <div className="flex justify-between">
            <h3 className="font-normal lg:text-lg xl:text-xl xlarge:text-2xl">
              Book a Walk - In Appointment
            </h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 cursor-pointer"
              onClick={closeModal}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        )}

        {checkPermission(permission?.allowed_features, 1004) && (
          <div className="send-noti mb-2">
            <input
              type="checkbox"
              checked={isInstitution}
              onClick={handleInstitutionToggle}
            />
            <label
              className="lg:text-base xl:text-lg xlarge:text-xl"
              style={{ marginBottom: '0px' }}
            >
              Institution Customer
            </label>
          </div>
        )}

        {isInstitution && (
          <div className="bookslot-firstrow">
            <label className="lg:text-sm xl:text-base xlarge:text-xl">
              Select Customer
            </label>
            <CuDropdown
              placeholder="Select customer"
              options={institutionOptions}
              onChange={handleInstitutionChange}
              searchable
              onSearch={(val) => setInstitutionSearchInput(val)}
            />
          </div>
        )}
        {clinicOptions && (
          <>
            <label className="lg:text-sm xl:text-base xlarge:text-xl">
              Select Clinic
            </label>
            <CuDropdown
              onChange={handleSelectClinicOption}
              placeholder="Select Clinic"
              options={clinicOptions}
              value={selectedClinicOption}
            />
          </>
        )}

        <div className="flex gap-12 w-full">
          <div className="w-1/2">
            <InputField
              label={'Phone No'}
              type={'number'}
              placeholder="Phone No"
              required
              value={value?.user_details?.phone}
              onChange={(e) =>
                onChange({ phone: e.target.value }, 'user_details')
              }
              loading={isLoading}
              disabled={isInstitution && institutionCustmer?.length === 0}
            />
          </div>

          <div className="w-1/2">
            {(existingUserOptions?.length === 0 || isEdit) && (
              <InputField
                label={'Full Name'}
                type={'text'}
                placeholder="Name"
                required
                value={value?.user_details?.full_name}
                onChange={(e) =>
                  onChange(
                    {
                      full_name: e.target.value,
                      isParent: true,
                      family_id: value?.user_details?.phone,
                    },
                    'user_details',
                  )
                }
                isEdit={isEdit}
                setIsEdit={setIsEdit}
              />
            )}

            {existingUserOptions?.length > 0 && !isEdit && (
              <>
                <label className="custom-input-field-label lg:text-sm xl:text-base xlarge:text-xl">
                  {'Full name'}
                </label>
                <div className="">
                  <CuDropdown
                    options={existingUserOptions}
                    placeholder={'Select or add member'}
                    value={
                      value?.user_details?.id || value?.user_details?.full_name
                    }
                    onChange={(val) => onChange(val, 'userId')}
                    searchable
                    allowAdditions
                    onAddItem={(val) => checkIsInstitution(val)}
                    required
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <div className="bookslot-firstrow">
          <DateAge
            value={{
              age: value?.user_details?.age,
              dob: value?.user_details?.dob,
            }}
            onChange={(val) => onChange(val, 'user_details')}
            id="date-age-custom"
            placeholder="age"
          />
        </div>

        <div className="bookslot-firstrow mt-1">
          <label className="lg:text-sm xl:text-base xlarge:text-xl">
            Gender
          </label>
          <div className="bookslot-gender">
            {gender.map((gen) => (
              <div
                key={gen.id}
                className="bookslot-genderbtns mb-2 cursor-pointer"
                onClick={(e) => onChange({ gender: gen.label }, 'user_details')}
              >
                <input
                  type="radio"
                  className="cursor-pointer"
                  checked={value?.user_details?.gender === gen.label}
                />
                <label className="lg:text-sm xl:text-base xlarge:text-xl cursor-pointer">
                  {gen.label}
                </label>
              </div>
            ))}
          </div>

          {errors.gender && <div className="error">{errors.gender}</div>}
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-2 w-full">
          {checkPermission(permission?.allowed_features, 1001) &&
            customFields?.map((cfield) => {
              return (
                <>
                  <div>
                    <InputField
                      label={cfield?.display_name}
                      type={cfield?.type}
                      value={value?.InjuryNumber}
                      onChange={(e) => onChange(e.target.value, 'InjuryNumber')}
                    />
                  </div>
                </>
              );
            })}

          {checkPermission(permission?.allowed_features, 1002) && (
            <div>
              <InputField
                label={'IPD Number'}
                type={'text'}
                value={value?.ipdNumber}
                onChange={(e) => onChange(e.target.value, 'ipdNumber')}
              />
            </div>
          )}

          {checkPermission(permission?.allowed_features, 1003) && (
            <div className="bookslot-firstrow">
              <InputField
                label={'OPD Number'}
                type={'text'}
                value={value?.opdNumber}
                onChange={(e) => onChange(e.target.value, 'opdNumber')}
              />
            </div>
          )}

          <div>
            <InputField
              label={'Start Time'}
              type={'time'}
              value={value?.start_time}
              disabled={manualTime?.manualTime ? false : true}
              onChange={(e) => onChange(e.target.value, 'start_time')}
            />
          </div>
        </div>

        <div className="bookslot-firstrow">
          <div className="cu-appointment-checkbox-cont">
            <div className="send-noti mb-2">
              <input
                type="checkbox"
                checked={isNotification}
                onChange={() => setIsNotification((prev) => !prev)}
              />
              <label
                className="lg:text-base xl:text-lg xlarge:text-xl"
                style={{ marginBottom: '0px' }}
              >
                Send Notification
              </label>
            </div>
          </div>
        </div>
        <div className="btn-center">
          <CustomButton
            color={'rgba(199, 234, 201, 1)'}
            textColor={'rgba(0, 0, 0, 1)'}
            className="btn-mobile lg:h-11 xl:h-12 w-full"
            // style={{ width: "100%", height: "40px" }}
            type="submit"
            loading={bookbtnLoading}
          >
            <span className="lg:text-base xl:text-lg xlarge:text-xl">
              Book Appointment
            </span>
          </CustomButton>
        </div>
      </CuForm>
    </>
  );
};

export default BookSlot;
